import { render, staticRenderFns } from "./FallbackNodeEditor.vue?vue&type=template&id=10e011fa&scoped=true&"
import script from "./FallbackNodeEditor.vue?vue&type=script&lang=js&"
export * from "./FallbackNodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./FallbackNodeEditor.vue?vue&type=style&index=0&id=10e011fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e011fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
installComponents(component, {
  VTab,
  VTabItem,
  VTabs,
  VTabsItems,
})
